import storage from '@/store/storage/storage';

const STORAGE_KEY = 'trackedPurchases';
const MAX_ENTRIES = 50;

const readTrackedIds = (): string[] => {
    try {
        const value = JSON.parse(storage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(value) ? value : [];
    } catch {
        return [];
    }
};

/**
 * True when a purchase conversion was already sent for any of the given ids
 * (payment id from the success URL or application reference).
 */
export const isPurchaseTracked = (...ids: Array<string | undefined>): boolean => {
    const trackedIds = readTrackedIds();

    return ids.some(id => !!id && trackedIds.includes(id));
};

export const markPurchaseTracked = (...ids: Array<string | undefined>): void => {
    const trackedIds = readTrackedIds();
    ids.forEach(id => {
        if (id && !trackedIds.includes(id)) {
            trackedIds.push(id);
        }
    });

    try {
        storage.setItem(STORAGE_KEY, JSON.stringify(trackedIds.slice(-MAX_ENTRIES)));
    } catch {
        // storage unavailable (e.g. private mode): the success page reset still prevents most repeats
    }
};
